module.exports = __webpack_public_path__ + "static/media/defaultBG.111d2dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/defaultBG.png
// module id = 465
// module chunks = 0